import useLang from "../../../hooks/useLang";
import { useParams } from "react-router-dom";
import useConclusion from "./useConclusion";

const operators = {
  gt: ">",
  gte: "≥",
  lt: "<",
  lte: "≤",
};

const useConclusionRulesBlock = () => {
  const lang = useLang();
  const { conclusionId } = useParams();
  const conclusion = useConclusion(
    { id: conclusionId },
    { skip: conclusionId == null }
  );

  const ruleDisplay = Array.isArray(conclusion?.data?.rules)
    ? conclusion?.data?.rules.map((rule) => {
        const operatorKey = Object.keys(rule?.operator)[0];
        if (rule?.parameter?.toLowerCase() === "age")
          return {
            ruleString: `${lang("captions." + rule.parameter)} ${
              operators[operatorKey]
            } ${rule.operator[operatorKey]}`,
          };
        return {
          ruleString: `${lang("captions." + rule.parameter)}: ${lang(
            "captions." + rule.operator[operatorKey]
          )}`,
        };
      })
    : [];

  const ruleFormData = Array.isArray(conclusion?.data?.rules)
    ? conclusion?.data?.rules.map((rule) => {
        return {
          parameter: rule?.parameter,
          operator: Object.keys(rule?.operator)[0],
          operatorValue: rule.operator[Object.keys(rule?.operator)],
        };
      })
    : [];

  const ageRuleFromData = ruleFormData?.filter(
    (item) => item?.parameter?.toLowerCase() === "age"
  );

  const genderRuleFromData = ruleFormData?.filter(
    (item) => item?.parameter?.toLowerCase() === "gender"
  );

  const ageOperatorOptions = Object.keys(operators).map((operatorKey) => ({
    id: operatorKey,
    label: operators[operatorKey],
  }));

  const genderValueOptions = [
    { id: "M", label: lang("captions.m") },
    { id: "F", label: lang("captions.f") },
  ];

  const items = [
    {
      id: "ruleString",
      type: "list",
      data: ruleDisplay,
      pageOnly: true,
    },
    {
      id: "age",
      type: "matrix",
      valueData: ageRuleFromData,
      formOnly: true,
      addButtonCaption: lang("conclusions.add_age_rule"),
      inputs: [
        {
          type: "label",
          value: lang("captions.age"),
          inputWidth: "quarter",
        },
        {
          id: "operator",
          type: "dropdown-selector",
          noEmpty: true,
          options: ageOperatorOptions,
          idAsValue: true,
          inputWidth: "quarter",
        },
        {
          id: "operatorValue",
          inputWidth: "quarter",
        },
      ],
    },
    {
      id: "gender",
      type: "matrix",
      valueData: genderRuleFromData,
      formOnly: true,
      addButtonCaption: lang("conclusions.add_gender_rule"),
      inputs: [
        {
          type: "label",
          value: lang("captions.gender"),
          inputWidth: "quarter",
        },
        {
          id: "operator",
          type: "hidden",
          value: "equals",
        },
        {
          id: "operatorValue",
          type: "dropdown-selector",
          noEmpty: true,
          options: genderValueOptions,
          idAsValue: true,
          inputWidth: "half",
        },
      ],
    },
  ];
  return items;
};

export default useConclusionRulesBlock;
